import { DocumentType } from 'shared/domains/apollo/generated/types';
import { isDocx, isPdf } from '../fileHelpers';
export const isPdfDocument = (document) => {
    const { files = [] } = document || {};
    const isUploaded = (document === null || document === void 0 ? void 0 : document.type) === DocumentType.Uploaded;
    const docxFile = files.find(isDocx);
    const pdfFile = files.find(isPdf);
    return isUploaded && !docxFile && Boolean(pdfFile);
};
